// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"c6882351","219":"4a10b9fc","661":"1d1efa91","817":"ab2a05b6","928":"615ad4f2"}[chunkId] + ".chunk.js";
};